import React from 'react';
import { Col, Row } from 'reactstrap';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import cabinCrewBasicInformationPropTypes from '../proptypes/CabinCrewPropTypes';
import { ITINERARY_PATH } from '../../../../../config/paths';
import Table from '../../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import {
  CABIN_CREW_CONTRACT_COLUMNS,
  CABIN_CREW_DOCUMENT_COLUMNS,
  CABIN_CREW_ITINERARY_COLUMNS,
} from '../../../../../config/columns';
import Alert from '../../../../common/informative/Alert';
import CustomerBasicInformationResource from '../../../user/customer/resource/CustomerBasicInformationResource';
import CustomerContactInformationResource from '../../../user/customer/resource/CustomerContactInformationResource';
import CabinCrewMovementsHistoryBasicResource from './CabinCrewMovementsHistoryBasicResource';

const CabinCrewBasicInformationResource = ({
  customer,
  cabinCrewType: { name: cabinCrewTypeName },
  location: { name: locationName },
  crewStatus: { name: crewStatusName },
  imageUrl,
  cabinCrewMovementHistoryList,
  cabinCrewDocumentList,
  cabinCrewContractList,
  loadingTrips,
  cabinCrewTrips,
  dispatchGetCabinCrewTripsTable,
}) => (
  <>
    <Row>
      <Col md={4}>
        <h3>Información Básica</h3>
        <CustomerBasicInformationResource {...customer} isDriver />
      </Col>
      <Col md={4}>
        <h3>Información de Contacto</h3>
        <CustomerContactInformationResource {...customer} />
      </Col>
      <Col md={4}>
        <h3>Foto</h3>
        <img
          src={imageUrl}
          className="img-fluid"
          aria-hidden="true"
          width={300}
          alt=""
        />
      </Col>
    </Row>
    <h3>Documentos</h3>
    {cabinCrewDocumentList.length > 0 ? (
      <Table
        columns={CABIN_CREW_DOCUMENT_COLUMNS}
        data={cabinCrewDocumentList}
        defaultPageSize={
          cabinCrewDocumentList.length <= 10
            ? cabinCrewDocumentList.length
            : DEFAULT_PAGE_SIZE
        }
        showPagination={cabinCrewDocumentList.length > 10}
        manual={false}
        defaultFilterMethod={filterMethodCaseInsensitive}
      />
    ) : (
      <Alert type="warning" message="No hay documentos para mostrar" />
    )}
    <h3>Estado</h3>
    <ResourceProperty label="Tipo:">
      {cabinCrewTypeName || '-'}
    </ResourceProperty>
    <ResourceProperty label="Base:">{locationName || '-'}</ResourceProperty>
    <ResourceProperty label="Estado:">{crewStatusName || '-'}</ResourceProperty>
    <h3>Contratos</h3>
    {cabinCrewContractList.length > 0 ? (
      <Table
        columns={CABIN_CREW_CONTRACT_COLUMNS}
        data={cabinCrewContractList}
        defaultPageSize={
          cabinCrewContractList.length <= 10
            ? cabinCrewContractList.length
            : DEFAULT_PAGE_SIZE
        }
        showPagination={cabinCrewContractList.length > 10}
        manual={false}
        defaultFilterMethod={filterMethodCaseInsensitive}
      />
    ) : (
      <Alert type="warning" message="No hay contratos para mostrar" />
    )}
    <h3>Viajes Recientes</h3>
    <Table
      columns={CABIN_CREW_ITINERARY_COLUMNS}
      data={cabinCrewTrips.get('content') || []}
      pages={cabinCrewTrips.get('totalPages') || null}
      defaultPageSize={cabinCrewTrips.get('size' || DEFAULT_PAGE_SIZE)}
      fetchData={dispatchGetCabinCrewTripsTable}
      modelPath={ITINERARY_PATH}
      loading={loadingTrips}
      navigateToModelOnRowClick
    />
    <CabinCrewMovementsHistoryBasicResource
      cabinCrewMovementHistoryList={cabinCrewMovementHistoryList}
    />
  </>
);

CabinCrewBasicInformationResource.propTypes =
  cabinCrewBasicInformationPropTypes;

export default CabinCrewBasicInformationResource;
